import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { AppRoutes } from "./Routes";
import "./core/coreStyles/globalStyles.scss";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(React.StrictMode, { children: _jsx(AppRoutes, {}) }));
